export default "//static.tradera.net/touchweb/static/output/images/app-download-desktop-2x.76efb739.png";